export const QuoteIcon = () => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.1237 23.272V17.112L20.7317 4H23.9877V23.272H17.1237ZM4.01172 23.272V17.112L7.70772 4H10.8757V23.272H4.01172Z"
                fill="#E00000"
            />
        </svg>
    );
};
